module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/6a Vysoky rostenec Rib eye steak tomahawk.jpg";